import { ListingTypes } from '../../../../api-client/enums'
import ListItemCheckbox from './list-item-checkbox'

export default function ListingTypeFilter({ checkedTypes, onChange }) {
  return (
    <div className='wrapper'>
      <p className='filterLabel'>Listing Type</p>
      <ul className='flex flexDirectionColumn'>
        {ListingTypes.map(({ label, value }) => (
          <ListItemCheckbox
            key={label}
            checked={!!checkedTypes[value]}
            value={value}
            onChange={onChange}
          >
            {label}
          </ListItemCheckbox>
        ))}
      </ul>

      <style jsx>{`
        .wrapper {
          padding: 2rem;
          border-radius: 1rem;
          background: #fff;
          box-shadow: 0 0.3rem 0.6rem rgba(0, 0, 0, 0.16);
          color: var(--secondary-text-color);
        }

        .filterLabel {
          font-size: 1.6rem;
          font-weight: 700;
        }

        @media (max-width: 1024px) {
          .wrapper {
            max-width: 100%;
            padding: 2rem 1.3rem;
            box-shadow: none;
            border-radius: 0;
          }

          .filterLabel {
            font-size: 1.2rem;
          }
        }
      `}</style>
    </div>
  )
}
